/** Keyboard-accessible multi-select chips (native buttons with aria-pressed). */
const ChipGroup = ({ options, selected, onToggle, testIdPrefix, ariaLabel }) => (
  <div className="flex flex-wrap gap-3" role="group" aria-label={ariaLabel}>
    {options.map((opt) => {
      const active = selected.includes(opt);
      return (
        <button
          key={opt}
          type="button"
          aria-pressed={active}
          data-testid={`${testIdPrefix}-${opt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          onClick={() => onToggle(opt)}
          className={`px-4 py-2.5 rounded-sm border text-sm text-left transition-colors duration-300 ${
            active
              ? "bg-eucalyptus text-cream border-eucalyptus"
              : "bg-cream text-charcoal border-charcoal/25 hover:border-ochre hover:text-ochre-dark"
          }`}
        >
          {opt}
        </button>
      );
    })}
  </div>
);

export default ChipGroup;
